
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const OilpriceModule = namespace("oilprice");
const FederalStatesModule = namespace("federalstates");

interface ResultItem {
  class: string;
  value: number;
  unit: string;
  period: string;
}

@Component
export default class PelletsConsumption extends Vue {
  @Prop({ type: String, required: true }) readonly city!: string;
  @Prop({ type: String, required: true }) readonly zipcode!: string;

  @OilpriceModule.Action("fetchConsumptionPelletsRequirement")
  fetchConsumptionPelletsRequirement!: (params: any) => Promise<void>;

  @OilpriceModule.State("energyClassConsumption")
  energyClassConsumption: any;

  @FederalStatesModule.State("cityPriceHistory")
  cityPriceHistory!: any;

  @FederalStatesModule.State("pelletsPriceHistory")
  pelletsPriceHistory;

  @OilpriceModule.State("consumptionOilRequirement")
  consumptionOilRequirement!: {
    literRequirement: number;
    annualPrice: number;
    monthlyPrice: number;
  };

  @OilpriceModule.State("cityHistoryChartData")
  cityHistoryChartData: any;

  selectedEnergyClass: number | null = null;
  squareMeters = 100;
  showErrorMessage = false;

  heizwertMultiplier = 2;

  get hasResults(): boolean {
    return this.selectedEnergyClass !== null;
  }

  get resultItems(): ResultItem[] {
    return [
      {
        class: "primary",
        value:
          this.consumptionOilRequirement.literRequirement *
            this.heizwertMultiplier || 0,
        unit: " KG",
        period: "/ Jahr",
      },
      {
        class: "secondary",
        value: this.consumptionOilRequirement.annualPrice || 0,
        unit: " €",
        period: "/ Jahr",
      },
      {
        class: "tertiary",
        value: this.consumptionOilRequirement.monthlyPrice || 0,
        unit: " €",
        period: "/ Monat",
      },
    ];
  }

  handleEnergyClassChange(value: number): void {
    this.selectedEnergyClass = value;
  }

  handleSquareMeterChange(value: number): void {
    this.squareMeters = Number(value || 0);
  }

  async calculatePelletsConsumption(): Promise<void> {
    if (!this.selectedEnergyClass) {
      this.showErrorMessage = true;
      return;
    }
    this.showErrorMessage = false;

    await this.fetchConsumptionPelletsRequirement({
      energyClass: Number(this.selectedEnergyClass) || 0,
      squareMeter: Math.min(Math.max(10, this.squareMeters), 10000),
      zipcode: this.zipcode,
      oilPrice: Math.round(
        (this.pelletsPriceHistory.loose.data[
          this.pelletsPriceHistory.loose.data.length - 1
        ].y *
          this.heizwertMultiplier) /
          10,
      ),
    });
  }
}
